export const setup = (vueInstance, continueWith) => {
  window.addEventListener('beforeunload', function (e) {
    let confirmMsg = vueInstance.$t('default_save_dialog.unsavedchanges');
    if (vueInstance.hasMutations) {
      let nexthref = document.activeElement.href; // next "active link (click on different link)"
      (e || window.event).returnValue = confirmMsg; // Gecko + IE
      if (nexthref) {
        continueWith(() => {
          window.location = nexthref;
        });
      }
      return confirmMsg; // Gecko + Webkit, Safari, Chrome etc.
    }
  });
};


/**
 *
 *
 * @param {Vue} vueInstance
 * @param {Function} continueWith
 * @param {Promise<boolean>} save
 * @param {Promise<boolean>} discart
 */
export const defaultSaveDialog = (vueInstance, save, discart) => (continueWith) => {
  vueInstance.$dialogs.confirm(vueInstance.$t('default_save_dialog.savechanges'), vueInstance.$t('default_save_dialog.save'),
    async () => {
      vueInstance.$log('on save');
      continueWith(await save());
    }, async () => {
      vueInstance.$log('on discart');
      continueWith(await discart());
    }, () => {
      vueInstance.$log('on cancel');
    }, vueInstance.$t('default_save_dialog.save'), vueInstance.$t('default_save_dialog.clear'), vueInstance.$t('default_save_dialog.cancel'));
};
